import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { ReactNode } from "react";

export type EmptyStateProps = {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
  action?: ReactNode;
  compact?: boolean;
};

export function EmptyState({
  title = "No results",
  description,
  icon,
  action,
  compact = false,
}: EmptyStateProps) {
  return (
    <Stack
      spacing={compact ? 0.75 : 1.25}
      alignItems="center"
      sx={{ py: compact ? 4 : 6, px: 2, textAlign: "center" }}
    >
      <Box
        sx={{
          width: compact ? 40 : 48,
          height: compact ? 40 : 48,
          borderRadius: "10px",
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: "rgba(27, 30, 51, 0.06)",
          color: "text.secondary",
          mb: 0.5,
        }}
      >
        {icon ?? <InboxOutlinedIcon fontSize={compact ? "small" : "medium"} />}
      </Box>
      <Typography variant="subtitle2" color="text.primary">
        {title}
      </Typography>
      {description != null && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 360 }}>
          {description}
        </Typography>
      )}
      {action != null && <Box sx={{ pt: 0.5 }}>{action}</Box>}
    </Stack>
  );
}

export default EmptyState;
